<template>
  <div :class="{ opacity: period.limit }">
    <div
      class="period-header"
      :class="{
        'period-header-7': type == 7,
        disabled: !$services.CourseService.checkLiveState(type, period),
      }"
      @click="targetPeriod(period)"
    >
      <div
        class="period-title"
        :class="{
          activePeriod: period.id == period_id,
          'period-title-10': type == 10,
        }"
        :title="period.periods_title"
      >
        <span class="period-point" :class="{ 'period-point-try': period.is_try_see }"></span>
        <span class="period-try" v-if="period.is_try_see">{{ tryText }}</span>
        <CoursePeriodsType :periods_type="period.periods_type"></CoursePeriodsType>

        <span class="period-title-content">{{ period.periods_title }}</span>
        <div
          class="period-state"
          :class="'period-state' + period.play_type.toString()"
          v-if="type != 5 && type != 10 && videoMixCoures"
        >
          <template v-if="type == 2 || type == 15 || type == 3">
            <template v-if="period.play_type == 1">
              <img src="@/assets/images/course/period-notbegin@2x.png" />
              <span>未开始</span>
            </template>
            <template v-else-if="period.play_type == 2">
              <img src="@/assets/images/course/period-progress@2x.png" />
              <span>直播中</span>
            </template>
            <template v-else>
              <img src="@/assets/images/course/period-end-1@2x.png" />
              <span>已结束</span>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div class="period-info" v-if="type != 5 && type != 10 && !videoMixCoures">
      <div class="period-teacher">
        <span class="period-teacher-name" v-if="!$route.query.video_id && period.periods_type != 5">
          讲师：{{ period.teachers ? period.teachers.join('/') : '' }}
        </span>
        <template v-if="period.start_play">
          <span class="line" v-if="!$route.query.video_id">|</span>
          <span>{{ period.start_play + ' ~ ' + period.end_play }}</span>
        </template>
      </div>
      <div
        class="period-state"
        :class="'period-state' + period.play_type.toString()"
        v-if="type != 5 && type != 10"
      >
        <template v-if="type == 2 || type == 15 || type == 3">
          <template v-if="period.play_type == 1">
            <img src="@/assets/images/course/period-notbegin@2x.png" />
            <span>未开始</span>
          </template>
          <template v-else-if="period.play_type == 2">
            <img src="@/assets/images/course/period-progress@2x.png" />
            <span>直播中</span>
          </template>
          <template v-else>
            <img src="@/assets/images/course/period-end@2x.png" />
            <span>已结束</span>
          </template>
          <!-- <template v-else-if="period.play_type == 3">查看回放</template>
          <template v-else-if="period.play_type == 4||period.play_type == 5">查看回放</template>-->
        </template>
        <template v-else-if="type == 7">
          <template v-if="period.play_type == 1">未开始</template>
          <template v-else-if="period.play_type == 2">上课中</template>
          <template v-else-if="period.play_type == 3">已结束</template>
        </template>
      </div>
    </div>
    <span
      v-if="$route.query.video_id && period.periods_type != 5 && period.periods_type != 10"
      class="period-teacher-name"
      style="margin-top: 10px"
    >
      讲师：{{ period.teachers ? period.teachers.join('/') : '' }}
    </span>
    <div class="period-files" v-if="period.files.length">
      <div
        v-for="(file, index) in period.files"
        class="period-file-wrap"
        :key="index"
        :title="file.file_name"
      >
        <div class="period-file clearfix" :title="file.file_name" @click="onPreview(file)">
          <img
            :src="require(`@/assets/images/course/${file.file_ext}-icon@2x.png`)"
            class="file-type"
          />
          <span>
            {{ file.file_name }}
          </span>
        </div>
      </div>
    </div>
    <CourseContentTip
      v-if="showContentDialog"
      :show.sync="showContentDialog"
      :content="chapter_content"
    ></CourseContentTip>
    <CourseSoldOutTip :show.sync="showSoldOut"></CourseSoldOutTip>
  </div>
</template>
<script>
import CourseSoldOutTip from '@/modules/stu/components/CourseSoldOutTip.vue';
import CoursePeriodsType from '@/modules/stu/components/CoursePeriodsType';
import CourseContentTip from '@/modules/stu/components/CourseContentTip';
export default {
  name: 'CoursePeriod',
  components: { CourseSoldOutTip, CoursePeriodsType, CourseContentTip },
  props: {
    period: {
      type: Object,
    },
    course: {
      type: Object,
    },
    tryText: {
      type: String,
      default: '试看',
    },
    isVideo: {
      type: Boolean,
    },
    onPeriodTap: {
      type: Function,
    },
  },
  data() {
    return {
      parent: this.$route.query.parent,
      period_id: this.$route.query.period_id,
      showContentDialog: false,
      chapter_content: '',
      showSoldOut: false,
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.period_id = this.$route.query.period_id;
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {
    commonSetting() {
      return this.$store.state.commonSetting;
    },
    type() {
      return this.period.periods_type;
    },
    // 是否是会员
    isShowVipFree() {
      if (this.$store.state.token && this.course.vipData.is_vip_course == 1) {
        return true;
      }
      return false;
    },
    // video页混合课
    videoMixCoures() {
      if (this.isVideo) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    // this.period.teachers = this.period.teachers.map(i => {
    //   return i.teacher_name;
    // });
  },
  methods: {
    async onPreview(file) {
      if (!this.course.is_buy && !this.isShowVipFree) {
        return this.$info('请您先报名');
      }
      if (file.file_ext == 'mp3' || file.file_ext == 'mp4') {
        let data = await this.$http.get('/api/app/user/CourseWare/video/preview', {
          video_id: file.fid,
        });
        // window.open(data[0].url);
        this.open(data[0].url);
      } else {
        let data = await this.$http.get('/api/app/user/CourseWare/preview', {
          fid: file.fid,
        });
        // window.open(data);
        this.open(data);
      }
    },
    open(url) {
      let hasOrigin = false;
      try {
        const urlObj = new URL(url);
        // 如果 URL 对象成功创建，并且 origin 属性存在
        hasOrigin = !!urlObj.origin;
      } catch (e) {
        // 如果 URL 对象创建失败（例如，urlString 不是一个有效的 URL），则返回 false
        hasOrigin = false;
      }
      url = hasOrigin ? url : `${location.origin}${url}`;

      //桌面端内
      if (this.$store.state.desktop) {
        // 支持安全锁的版本
        if (this.$store.state.desktop.deviceInfo) {
          this.$router.push({
            name: 'Iframe',
            query: {
              url: this.ensureHttps(url),
            },
          });
        } else {
          this.$store.state.desktop.openurl(this.ensureHttps(url)); // 不支持安全锁的版本
        }
      } else {
        //桌面端外
        window.open(url);
      }
    },
    ensureHttps(url) {
      // 使用 URL 对象解析输入的 URL
      const parsedUrl = new URL(url);

      // 检查协议是否为 'https:'
      if (parsedUrl.protocol !== 'https:') {
        // 如果不是 'https:'，则修改为 'https:'
        parsedUrl.protocol = 'https:';
      }

      // 返回修改后的 URL 字符串
      return parsedUrl.toString();
    },
    async visitFile(id, index) {
      if (this.course.is_buy == 0) {
        return this.$info('请您先报名');
      }
      await this.$services.CourseService.openPeriodFile(this.period, id, index, this.parent);
    },
    async targetPeriod(period, type) {
      if (period.limit == 1) {
        return this.$info('访问被限制，请联系老师');
      }
      if (!this.$services.CourseService.checkLiveState(this.type, period)) {
        return;
      }
      if (this.course.is_buy == 0 && period.is_try_see == 0) {
        return this.$info('请您先报名');
      }
      if (this.course.is_buy == 1) {
        await this.$services.CourseService.checkLimit(this.course.id, period.id);
        if (!this.$services.CourseService.checkBuyValid(this.course)) {
          return this.$info('该课程已过期，无法继续学习');
        }
      }
      /*
      if (period.bjy_encode_status != 1) {
        return this.$info("视频转码中，请稍后观看");
      }
      */
      if (this.videoMixCoures && this.type == 5) {
        this.onPeriodTap();
      }
      if (this.type == 7 && this.period.content) {
        this.chapter_content = this.period.content;
        this.showContentDialog = true;
        return;
      }
      if (this.type == 10) {
        let data = await this.$services.CourseService.getPeriodContent(period, this.parent);
        this.chapter_content = data.course_content;
        this.showContentDialog = true;
      } else {
        if (!type) {
          type = 1;
        }
        await this.$services.CourseService.watchVideo(period, this.type, this.course.id, type);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.period-header {
  display: flex;
  align-items: center;
}

.opacity {
  opacity: 0.5;
}
.period-header:not(.period-header-7) {
  cursor: pointer;

  &:hover {
    .period-title-content {
      color: $primary-color;
    }
  }

  &.disabled {
    cursor: default;
  }
}
.activePeriod {
  .period-title-content {
    color: $primary-color !important;
  }
}
.period-title {
  font-size: 16px;
  color: #595959;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-bottom: 12px;
  padding-bottom: 3px;
  .period-title-content {
    height: 22px;
    // max-width: 365px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(89, 89, 89, 1);
    line-height: 22px;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.period-title-10 {
    width: auto;
  }
}

.period-try {
  font-size: 12px;
  color: white;
  display: inline-block;
  width: 44px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  background-image: url('~@/assets/images/course/try-back@2x.png');
  background-size: 100% 100%;
  margin-right: 8px;
}

.period-course-type {
  height: 22px;
  background: #ffffff;
  border: 1px solid $primary-color;
  border-radius: 12px;
  line-height: 20px;
  font-size: 12px;
  color: $primary-color;
  padding: 0 8px;
  box-sizing: border-box;
  margin-right: 12px;
}

.period-point {
  width: 5px;
  height: 5px;
  background-color: $primary-color;
  border-radius: 100%;
  display: inline-block;
  margin-right: 18px;
  flex-shrink: 0;

  &.period-point-try {
    margin-right: 8px;
  }
}

.period-files {
  padding-top: 12px;
}

.period-file-wrap {
  margin-bottom: 15px;
  height: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  .period-file {
    background: rgba(230, 0, 18, 0.02);
    border-radius: 16px;
    padding: 0 12px;
    height: 32px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #333333;
    .file-type {
      width: 26px;
      margin-right: 6px;
      float: left;
    }

    span {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      float: right;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .period-file:hover {
    color: $primary-color;
  }
}

.period-info {
  display: flex;
  align-items: center;
  height: 32px;
}

.period-teacher {
  font-size: 16px;
  color: #666666;
  flex: 1;
  display: flex;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 10px;

  .line {
    color: #cccccc;
    margin: 0 10px;
  }
}

.period-teacher-name {
  overflow: hidden;
  text-overflow: ellipsis;
}

.period-playback {
  margin-right: 14px;
  a {
    display: inline-block;
    width: 132px;
    height: 32px;
    border-radius: 16px;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    margin-right: 10px;
  }
}

.period-state {
  font-size: 14px;
  display: flex;
  align-items: center;
  white-space: nowrap;

  img {
    width: 14px;
    margin-right: 6px;
  }

  &.period-state2 {
    color: $primary-color;
  }

  &.period-state1,
  &.period-state3,
  &.period-state4,
  &.period-state5 {
    color: #999999;
  }
}
</style>
